module.exports = __webpack_public_path__ + "static/media/floral_big.d138bb1d.svg";